<template>
  <div id="alt-header-desktop" class="header-sg">
      <div class="main_logo is_desktop">
        <div class="header-nav__logo">
            <a
              :href="getLangUrl('/', baseUrl, locale)" 
              class="custom-logo-link"
              rel="home"
            >
              <NuxtImg  src="https://www.skjewellery.com/api/wp-content/uploads/2025/10/SK-Logo_Red.png" alt="SK Jewellery Logo" class="custom-logo header-logo-desktop"  />
            </a>
          </div>
      </div>
      <div class="pt_main_header">
        <div id="alt-header-top" class="container-fluid">
          <div class="header-nav__logo is_br_desktop">
            <a
              :href="getLangUrl('/', baseUrl, locale)" 
              class="custom-logo-link"
              rel="home"
            >
              <NuxtImg width="60" height="50" src="https://www.skjewellery.com/api/wp-content/uploads/nuxt/skj-logo-new.webp" alt="SK Jewellery Logo" class="custom-logo header-logo-desktop" sizes="sm:84px md:84px lg:84px" />
            </a>
          </div>
          <div class="alt-top-header row no-gutters justify-content-between">
            <div class="alt-header-top-right d-flex align-items-center justify-content-end">
              <div class="header-search">
                <form @submit.prevent="handleSearchSubmit" autocomplete="off" id="search-form">
                  <input type="text" name="s" placeholder="I am searching for..." v-model="searchInput" 
                                id="open-search" style="padding: 0px 20px !important;">
                  <span class="search__icon search__icon--loading"></span>
                  <span class="search__icon search__icon--glass"></span>
                  <input type="submit" value="Search" class="search-submit">
                  <svg version="1.1" class="header-svg header-svg--search" xmlns="http://www.w3.org/2000/svg" fill="#9E9E9E" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="111 -111 371 372" style="enable-background:new 111 -111 371 372;" xml:space="preserve" @click.prevent="handleSearchSubmit"> <path d="M268.1-106.9c6.1,0.9,12.2,1.6,18.2,2.8c30.6,6.2,56.8,20.6,77.9,43.7c28,30.6,40.8,66.9,38,108.3 c-1.9,27.4-11.3,52.3-27.7,74.5c-2.6,3.5-2.3,6.8,0.8,10c32.4,32.4,64.8,64.8,97.2,97.2c4.7,4.7,7.2,9.9,5.2,16.6 c-3,10.1-15.1,14-23.5,7.7c-1.4-1.1-2.7-2.3-3.9-3.6c-32.3-32.3-64.7-64.6-97-97c-2.8-2.8-5.8-3.1-8.9-0.7 c-18.4,13.8-39,22.9-61.7,26.5c-45.5,7.2-85.9-4.5-120.4-35.1c-25.5-22.7-40.5-51.4-46.1-85c-0.7-4.1-1.1-8.2-1.6-12.3 c0-6.4,0-12.8,0-19.2c0.6-4.2,1-8.4,1.8-12.6c5.8-34.4,21.8-63.3,48-86.3c19.2-16.8,41.4-27.6,66.4-32.6c6-1.2,12.1-1.9,18.1-2.8 C255.3-106.9,261.7-106.9,268.1-106.9L268.1-106.9z M372.3,37c-0.6-63-51.5-113.7-113.9-113.4C195.6-76.2,144.7-25.1,145,37.3 c0.3,62.9,50.9,113.6,113.8,113.4C322.7,150.5,372,99.2,372.3,37z"/> </svg>
                </form>
              </div>
              <div class="alt-header-icons">
                  <div class="alt-header-icons-my-acc">
                    <!-- <img class="header-country-selector-arrow" src="@/assets/images/icon_account.png" width="9" height="9" alt="" /> -->
                    <svg class="none-hover" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                      <path d="M18.75 9C18.75 7.6875 18 6.46875 16.875 5.76562C15.7031 5.10938 14.25 5.10938 13.125 5.76562C11.9531 6.46875 11.25 7.6875 11.25 9C11.25 10.3594 11.9531 11.5781 13.125 12.2812C14.25 12.9375 15.7031 12.9375 16.875 12.2812C18 11.5781 18.75 10.3594 18.75 9ZM9 9C9 6.89062 10.125 4.92188 12 3.84375C13.8281 2.76562 16.125 2.76562 18 3.84375C19.8281 4.92188 21 6.89062 21 9C21 11.1562 19.8281 13.125 18 14.2031C16.125 15.2812 13.8281 15.2812 12 14.2031C10.125 13.125 9 11.1562 9 9ZM6.79688 24.75H23.1562C22.7344 21.7969 20.2031 19.5 17.1094 19.5H12.8438C9.75 19.5 7.21875 21.7969 6.79688 24.75ZM4.5 25.6406C4.5 21 8.20312 17.25 12.8438 17.25H17.1094C21.75 17.25 25.5 21 25.5 25.6406C25.5 26.3906 24.8438 27 24.0938 27H5.85938C5.10938 27 4.5 26.3906 4.5 25.6406Z" fill="#333333"/>
                      <path d="M18.75 9C18.75 7.6875 18 6.46875 16.875 5.76562C15.7031 5.10938 14.25 5.10938 13.125 5.76562C11.9531 6.46875 11.25 7.6875 11.25 9C11.25 10.3594 11.9531 11.5781 13.125 12.2812C14.25 12.9375 15.7031 12.9375 16.875 12.2812C18 11.5781 18.75 10.3594 18.75 9ZM9 9C9 6.89062 10.125 4.92188 12 3.84375C13.8281 2.76562 16.125 2.76562 18 3.84375C19.8281 4.92188 21 6.89062 21 9C21 11.1562 19.8281 13.125 18 14.2031C16.125 15.2812 13.8281 15.2812 12 14.2031C10.125 13.125 9 11.1562 9 9ZM6.79688 24.75H23.1562C22.7344 21.7969 20.2031 19.5 17.1094 19.5H12.8438C9.75 19.5 7.21875 21.7969 6.79688 24.75ZM4.5 25.6406C4.5 21 8.20312 17.25 12.8438 17.25H17.1094C21.75 17.25 25.5 21 25.5 25.6406C25.5 26.3906 24.8438 27 24.0938 27H5.85938C5.10938 27 4.5 26.3906 4.5 25.6406Z" fill="black" fill-opacity="0.2"/>
                    </svg>
                    <svg class="on-hover" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                      <path d="M18.75 9C18.75 7.6875 18 6.46875 16.875 5.76562C15.7031 5.10938 14.25 5.10938 13.125 5.76562C11.9531 6.46875 11.25 7.6875 11.25 9C11.25 10.3594 11.9531 11.5781 13.125 12.2812C14.25 12.9375 15.7031 12.9375 16.875 12.2812C18 11.5781 18.75 10.3594 18.75 9ZM9 9C9 6.89062 10.125 4.92188 12 3.84375C13.8281 2.76562 16.125 2.76562 18 3.84375C19.8281 4.92188 21 6.89062 21 9C21 11.1562 19.8281 13.125 18 14.2031C16.125 15.2812 13.8281 15.2812 12 14.2031C10.125 13.125 9 11.1562 9 9ZM6.79688 24.75H23.1562C22.7344 21.7969 20.2031 19.5 17.1094 19.5H12.8438C9.75 19.5 7.21875 21.7969 6.79688 24.75ZM4.5 25.6406C4.5 21 8.20312 17.25 12.8438 17.25H17.1094C21.75 17.25 25.5 21 25.5 25.6406C25.5 26.3906 24.8438 27 24.0938 27H5.85938C5.10938 27 4.5 26.3906 4.5 25.6406Z" fill="#C60C46"/>
                      <path d="M18.75 9C18.75 7.6875 18 6.46875 16.875 5.76562C15.7031 5.10938 14.25 5.10938 13.125 5.76562C11.9531 6.46875 11.25 7.6875 11.25 9C11.25 10.3594 11.9531 11.5781 13.125 12.2812C14.25 12.9375 15.7031 12.9375 16.875 12.2812C18 11.5781 18.75 10.3594 18.75 9ZM9 9C9 6.89062 10.125 4.92188 12 3.84375C13.8281 2.76562 16.125 2.76562 18 3.84375C19.8281 4.92188 21 6.89062 21 9C21 11.1562 19.8281 13.125 18 14.2031C16.125 15.2812 13.8281 15.2812 12 14.2031C10.125 13.125 9 11.1562 9 9ZM6.79688 24.75H23.1562C22.7344 21.7969 20.2031 19.5 17.1094 19.5H12.8438C9.75 19.5 7.21875 21.7969 6.79688 24.75ZM4.5 25.6406C4.5 21 8.20312 17.25 12.8438 17.25H17.1094C21.75 17.25 25.5 21 25.5 25.6406C25.5 26.3906 24.8438 27 24.0938 27H5.85938C5.10938 27 4.5 26.3906 4.5 25.6406Z" fill="#C60C46" fill-opacity="0.2"/>
                    </svg>
                    <div class="alt-header-user" v-if="userStore.isLogin">
                      <div class="alt-header-user-name">Welcome <a href="#" @click="toggleHeaderUser($event)"><span class="user-header-name">{{ userStore.user?.display_name }}</span></a></div>
                      <ul class="dropdown-menu-user">
                        <li><NuxtLink :to="getLangUrl(`my-account/`, baseUrl, locale)" no-prefetch>My Profile</NuxtLink></li>
                        <li><NuxtLink :to="getLangUrl(`my-account/orders/`, baseUrl, locale)" no-prefetch>Orders</NuxtLink></li>
                        <li>
                          <NuxtLink :to="getLangUrl(`my-account/edit-account/#change-password/`, baseUrl, locale)" no-prefetch
                            >Reset Password</NuxtLink
                          >
                        </li>
                        <li>
                          <a
                            :href="`${runtimeConfig.public.BASE_URL}api/logout/`"
                            class="menu-logout"
                            >Logout</a
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="alt-header-user alt-header-user--guest" v-else>
                      <NuxtLink :to="getLangUrl(`my-account/`, baseUrl, locale)" class="alt-header-top-right-guest" no-prefetch>Login/Register</NuxtLink>
                    </div>
                  </div>
                  <div class="alt-header-icons-wishlist">
                    <NuxtLink aria-label="Wishlist" :to="getLangUrl(`/wishlist/${share_key_cookie.value ? share_key_cookie.value + '/' : ''}`, baseUrl, locale)" no-prefetch>
                      <svg class="none-hover" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <path d="M13.5469 24.9844L13.4531 24.8438L5.25 17.25C3.79688 15.8906 3 14.0156 3 12.0469V11.9062C3 8.625 5.34375 5.76562 8.57812 5.15625C10.4062 4.78125 12.2812 5.20312 13.8281 6.28125C14.25 6.5625 14.625 6.9375 15 7.3125C15.1875 7.125 15.375 6.89062 15.6094 6.70312C15.7969 6.5625 15.9844 6.42188 16.1719 6.28125C17.6719 5.20312 19.5469 4.78125 21.375 5.15625C24.6562 5.76562 27 8.625 27 11.9062V12.0469C27 14.0156 26.1562 15.8906 24.7031 17.25L16.5 24.8438L16.4062 24.9844C16.0312 25.3125 15.5156 25.5469 15 25.5469C14.4375 25.5469 13.9688 25.3125 13.5469 24.9844ZM14.2031 9.79688C14.1562 9.79688 14.1562 9.79688 14.1562 9.75L13.3125 8.8125C12.2344 7.59375 10.5938 7.07812 9 7.35938C6.79688 7.78125 5.25 9.70312 5.25 11.9062V12.0469C5.25 13.4062 5.76562 14.6719 6.75 15.5625L15 23.2031L23.2031 15.5625C24.1875 14.6719 24.75 13.4062 24.75 12.0469V11.9062C24.75 9.70312 23.1562 7.78125 20.9531 7.35938C19.3594 7.07812 17.7188 7.59375 16.6406 8.8125L15.7969 9.75C15.7969 9.79688 15.7969 9.79688 15.75 9.84375C15.5625 10.0312 15.2812 10.1719 15 10.1719C14.6719 10.1719 14.3906 10.0312 14.2031 9.84375V9.79688Z" fill="#333333"/>
                        <path d="M13.5469 24.9844L13.4531 24.8438L5.25 17.25C3.79688 15.8906 3 14.0156 3 12.0469V11.9062C3 8.625 5.34375 5.76562 8.57812 5.15625C10.4062 4.78125 12.2812 5.20312 13.8281 6.28125C14.25 6.5625 14.625 6.9375 15 7.3125C15.1875 7.125 15.375 6.89062 15.6094 6.70312C15.7969 6.5625 15.9844 6.42188 16.1719 6.28125C17.6719 5.20312 19.5469 4.78125 21.375 5.15625C24.6562 5.76562 27 8.625 27 11.9062V12.0469C27 14.0156 26.1562 15.8906 24.7031 17.25L16.5 24.8438L16.4062 24.9844C16.0312 25.3125 15.5156 25.5469 15 25.5469C14.4375 25.5469 13.9688 25.3125 13.5469 24.9844ZM14.2031 9.79688C14.1562 9.79688 14.1562 9.79688 14.1562 9.75L13.3125 8.8125C12.2344 7.59375 10.5938 7.07812 9 7.35938C6.79688 7.78125 5.25 9.70312 5.25 11.9062V12.0469C5.25 13.4062 5.76562 14.6719 6.75 15.5625L15 23.2031L23.2031 15.5625C24.1875 14.6719 24.75 13.4062 24.75 12.0469V11.9062C24.75 9.70312 23.1562 7.78125 20.9531 7.35938C19.3594 7.07812 17.7188 7.59375 16.6406 8.8125L15.7969 9.75C15.7969 9.79688 15.7969 9.79688 15.75 9.84375C15.5625 10.0312 15.2812 10.1719 15 10.1719C14.6719 10.1719 14.3906 10.0312 14.2031 9.84375V9.79688Z" fill="black" fill-opacity="0.2"/>
                      </svg>
                      <svg class="on-hover" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <path d="M13.5469 24.9844L13.4531 24.8438L5.25 17.25C3.79688 15.8906 3 14.0156 3 12.0469V11.9062C3 8.625 5.34375 5.76562 8.57812 5.15625C10.4062 4.78125 12.2812 5.20312 13.8281 6.28125C14.25 6.5625 14.625 6.9375 15 7.3125C15.1875 7.125 15.375 6.89062 15.6094 6.70312C15.7969 6.5625 15.9844 6.42188 16.1719 6.28125C17.6719 5.20312 19.5469 4.78125 21.375 5.15625C24.6562 5.76562 27 8.625 27 11.9062V12.0469C27 14.0156 26.1562 15.8906 24.7031 17.25L16.5 24.8438L16.4062 24.9844C16.0312 25.3125 15.5156 25.5469 15 25.5469C14.4375 25.5469 13.9688 25.3125 13.5469 24.9844ZM14.2031 9.79688C14.1562 9.79688 14.1562 9.79688 14.1562 9.75L13.3125 8.8125C12.2344 7.59375 10.5938 7.07812 9 7.35938C6.79688 7.78125 5.25 9.70312 5.25 11.9062V12.0469C5.25 13.4062 5.76562 14.6719 6.75 15.5625L15 23.2031L23.2031 15.5625C24.1875 14.6719 24.75 13.4062 24.75 12.0469V11.9062C24.75 9.70312 23.1562 7.78125 20.9531 7.35938C19.3594 7.07812 17.7188 7.59375 16.6406 8.8125L15.7969 9.75C15.7969 9.79688 15.7969 9.79688 15.75 9.84375C15.5625 10.0312 15.2812 10.1719 15 10.1719C14.6719 10.1719 14.3906 10.0312 14.2031 9.84375V9.79688Z" fill="#C60C46"/>
                        <path d="M13.5469 24.9844L13.4531 24.8438L5.25 17.25C3.79688 15.8906 3 14.0156 3 12.0469V11.9062C3 8.625 5.34375 5.76562 8.57812 5.15625C10.4062 4.78125 12.2812 5.20312 13.8281 6.28125C14.25 6.5625 14.625 6.9375 15 7.3125C15.1875 7.125 15.375 6.89062 15.6094 6.70312C15.7969 6.5625 15.9844 6.42188 16.1719 6.28125C17.6719 5.20312 19.5469 4.78125 21.375 5.15625C24.6562 5.76562 27 8.625 27 11.9062V12.0469C27 14.0156 26.1562 15.8906 24.7031 17.25L16.5 24.8438L16.4062 24.9844C16.0312 25.3125 15.5156 25.5469 15 25.5469C14.4375 25.5469 13.9688 25.3125 13.5469 24.9844ZM14.2031 9.79688C14.1562 9.79688 14.1562 9.79688 14.1562 9.75L13.3125 8.8125C12.2344 7.59375 10.5938 7.07812 9 7.35938C6.79688 7.78125 5.25 9.70312 5.25 11.9062V12.0469C5.25 13.4062 5.76562 14.6719 6.75 15.5625L15 23.2031L23.2031 15.5625C24.1875 14.6719 24.75 13.4062 24.75 12.0469V11.9062C24.75 9.70312 23.1562 7.78125 20.9531 7.35938C19.3594 7.07812 17.7188 7.59375 16.6406 8.8125L15.7969 9.75C15.7969 9.79688 15.7969 9.79688 15.75 9.84375C15.5625 10.0312 15.2812 10.1719 15 10.1719C14.6719 10.1719 14.3906 10.0312 14.2031 9.84375V9.79688Z" fill="#C60C46" fill-opacity="0.2"/>
                      </svg>
                      
                    </NuxtLink>
                    <!-- <div class="tooltip_wish">Wishlist</div> -->
                  </div>
                  <div v-if="checkCart" class="alt-header-icons-cart" @click="openMiniCart($event)">
                    <svg class="none-hover" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                      <path d="M12 8.25V10.5H18V8.25C18 6.60938 16.6406 5.25 15 5.25C13.3125 5.25 12 6.60938 12 8.25ZM9.75 12.75H6.75V22.5C6.75 23.7656 7.73438 24.75 9 24.75H21C22.2188 24.75 23.25 23.7656 23.25 22.5V12.75H20.25V15.375C20.25 16.0312 19.7344 16.5 19.125 16.5C18.4688 16.5 18 16.0312 18 15.375V12.75H12V15.375C12 16.0312 11.4844 16.5 10.875 16.5C10.2188 16.5 9.75 16.0312 9.75 15.375V12.75ZM9.75 10.5V8.25C9.75 5.39062 12.0938 3 15 3C17.8594 3 20.25 5.39062 20.25 8.25V10.5H23.25C24.4688 10.5 25.5 11.5312 25.5 12.75V22.5C25.5 24.9844 23.4844 27 21 27H9C6.51562 27 4.5 24.9844 4.5 22.5V12.75C4.5 11.5312 5.48438 10.5 6.75 10.5H9.75Z" fill="#333333"/>
                      <path d="M12 8.25V10.5H18V8.25C18 6.60938 16.6406 5.25 15 5.25C13.3125 5.25 12 6.60938 12 8.25ZM9.75 12.75H6.75V22.5C6.75 23.7656 7.73438 24.75 9 24.75H21C22.2188 24.75 23.25 23.7656 23.25 22.5V12.75H20.25V15.375C20.25 16.0312 19.7344 16.5 19.125 16.5C18.4688 16.5 18 16.0312 18 15.375V12.75H12V15.375C12 16.0312 11.4844 16.5 10.875 16.5C10.2188 16.5 9.75 16.0312 9.75 15.375V12.75ZM9.75 10.5V8.25C9.75 5.39062 12.0938 3 15 3C17.8594 3 20.25 5.39062 20.25 8.25V10.5H23.25C24.4688 10.5 25.5 11.5312 25.5 12.75V22.5C25.5 24.9844 23.4844 27 21 27H9C6.51562 27 4.5 24.9844 4.5 22.5V12.75C4.5 11.5312 5.48438 10.5 6.75 10.5H9.75Z" fill="black" fill-opacity="0.2"/>
                    </svg>
                    <svg class="on-hover" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                      <path d="M12 8.25V10.5H18V8.25C18 6.60938 16.6406 5.25 15 5.25C13.3125 5.25 12 6.60938 12 8.25ZM9.75 12.75H6.75V22.5C6.75 23.7656 7.73438 24.75 9 24.75H21C22.2188 24.75 23.25 23.7656 23.25 22.5V12.75H20.25V15.375C20.25 16.0312 19.7344 16.5 19.125 16.5C18.4688 16.5 18 16.0312 18 15.375V12.75H12V15.375C12 16.0312 11.4844 16.5 10.875 16.5C10.2188 16.5 9.75 16.0312 9.75 15.375V12.75ZM9.75 10.5V8.25C9.75 5.39062 12.0938 3 15 3C17.8594 3 20.25 5.39062 20.25 8.25V10.5H23.25C24.4688 10.5 25.5 11.5312 25.5 12.75V22.5C25.5 24.9844 23.4844 27 21 27H9C6.51562 27 4.5 24.9844 4.5 22.5V12.75C4.5 11.5312 5.48438 10.5 6.75 10.5H9.75Z" fill="#C60C46"/>
                      <path d="M12 8.25V10.5H18V8.25C18 6.60938 16.6406 5.25 15 5.25C13.3125 5.25 12 6.60938 12 8.25ZM9.75 12.75H6.75V22.5C6.75 23.7656 7.73438 24.75 9 24.75H21C22.2188 24.75 23.25 23.7656 23.25 22.5V12.75H20.25V15.375C20.25 16.0312 19.7344 16.5 19.125 16.5C18.4688 16.5 18 16.0312 18 15.375V12.75H12V15.375C12 16.0312 11.4844 16.5 10.875 16.5C10.2188 16.5 9.75 16.0312 9.75 15.375V12.75ZM9.75 10.5V8.25C9.75 5.39062 12.0938 3 15 3C17.8594 3 20.25 5.39062 20.25 8.25V10.5H23.25C24.4688 10.5 25.5 11.5312 25.5 12.75V22.5C25.5 24.9844 23.4844 27 21 27H9C6.51562 27 4.5 24.9844 4.5 22.5V12.75C4.5 11.5312 5.48438 10.5 6.75 10.5H9.75Z" fill="#C60C46" fill-opacity="0.2"/>
                    </svg>
                    <span class="alt-cart-indicator">{{ wooStore.totalItemCart }}</span>
                    <!-- <div class="tooltip_cart">Cart</div> -->
                  </div>
                  
              </div>
            </div> <!-- End Right-->

          </div>
        </div>

        <div id="alt-header-menu-primary" class="header-nav__wrapper">
            <nav id="site-navigation" class="main-navigation">
              <div id="mega-menu-wrap-main-navigation-1" class="alt-menu-wrap-main-navigation">
                <HeaderItemMenu/>
              </div>
            </nav>
        </div>
      </div>
      
    </div>
</template>

<script lang="ts" setup>
const userStore = useUserStore();
const wooStore = useWooStore();
const runtimeConfig = useRuntimeConfig();
const router = useRouter();
const route = useRoute();
const eventBus = useEventBus();
const showSeclect = ref<boolean>(false);
const checkCart = ref(true);
const showPopUp = useCookie("showPopUp");
const hiddenMenu = ref<boolean>(true);
const currentRoute = router.currentRoute.value.path;
const share_key_cookie = ref("");
const searchInput = ref('');
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { getLangUrl } from '~/utils/getLangUrl';
const baseUrl = runtimeConfig.public.BASE_URL;


if (currentRoute.includes('/custom-admin/') ) {
    hiddenMenu.value = false;
}

import {
  headerMenuLayoutFive,
  toggleHeaderUser,
  headerUserMenuCloseOutside,
  getOSBrowser,
  layout7HoverEffect,
} from "@/assist/HeaderDesktop";
import type { ICurrencyItem } from "@/types/currencyItem";
import HeaderItemMenu from "@/components/Header/HeaderItemMenu.vue";
import { setCookie, getCookie } from "@/utils/cookie";

const handleNavigation = (event: MouseEvent) => {
  event.preventDefault();
  const targetUrl = "/";

  if (window.location.pathname === targetUrl) {
    window.location.href = targetUrl;
  } else {
    router.push(targetUrl);
  }
};

const shopPopupSelectCountry = () => {
  showSeclect.value = true;
  document.body.style.overflowY = "hidden";
};
const closePopup = (e) => {
  e.stopPropagation();
  showSeclect.value = false;
  document.body.style.overflowY = "auto";
  // console.log('checked')
  setCookie('showPopUp', 'checked', 1);
};
interface Props {
  cartItem: number;
}
// document.getElementById('country-selector_mobile').addEventListener('click', () => {
//   shopPopupSelectCountry();

// });

// document.getElementById('country-selector_mobile').addEventListener('touchend', () => {
//   shopPopupSelectCountry();
// });

// const handleLogout = async () => {
//   try {
//     await fetch(`${runtimeConfig.public.BASE_URL}api/logout/`, { method: 'POST' });
//     router.push('/login');
//   } catch (error) {
//     console.error("Logout failed:", error);
//   }
// };

// const handleSetCountry = (item: ICurrencyItem) => {
//   if (!item) return;
//   const countryShort = item.country_short;
//   const countryCurrency = item.currency;

//   if (countryShort == "AU") {
//     window.location.href = "https://www.skjewellery.com/au/";
//     return;
//   }else if(countryShort == "US"){
//     window.location.href = "https://www.skjewellery.com/us/";
//     return;
//   }else if(countryShort == "SG"){
//     window.location.href = "https://www.skjewellery.com/";
//     return;
//   }else if(countryShort == "MY"){
//     return;
//   }else{
//     window.location.href = "https://www.skjewellery.com/intl/";
//     return;
//   }

//   const country = wooStore.countries[countryShort];
//   if (country) {
//     const currency = wooStore.currencyList.settings[countryCurrency];
//     wooStore.setCountry(country);
//     wooStore.setCurrency(currency);

//     eventBus.emit("currency:change", {
//       country: countryShort,
//       currency: countryCurrency,
//       rate: currency.rate,
//       symbol: currency.symbol,
//     });



//     // console.log("countryCurrencyxxx", countryCurrency);

//     if (countryCurrency === "SGD" && route.path === "/intl/") {
//       router.push("/");
//     }
//     if (
//       countryCurrency !== "SGD" &&
//       route.path === "/" &&
//       route.params &&
//       !route.query.s
//     ) {
//       router.push("/intl/");
//     }
//   }

//   // console.log('handleSetCountry', country);
// };
withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
    (e: 'toggle-minicart'): void
}>();

const openMiniCart = (event: Event) => {
  event.preventDefault();
  emit('toggle-minicart');
};
const checkPageCart = () => {
  const slug = router.currentRoute.value.name;
  if (slug == "cart") {
    checkCart.value = false;
  } else {
    checkCart.value = true;
  }
};

const normalizeSearchTerm = (term: string): string => {
        return term
            .trim()
            .replace(/\s+/g, ' ')
            .replace(/\+/g, ' ')
            .trim();
    };

const handleSearchSubmit = async (event: Event) => {
    event.preventDefault();
    const searchValue = searchInput.value;
    const normalizedSearch = normalizeSearchTerm(searchValue);
    const encodedSearch = encodeURIComponent(normalizedSearch);
    searchInput.value = '';
    console.log('locale.value_search', locale.value);
    if(locale.value === 'ms-my') {
      await router.push(`/${locale.value}/search?q=${encodedSearch}`);
    }else{
      await router.push(`/search?q=${encodedSearch}`);
    }
};
// const updateFormAction = () => {
//   const form = document.getElementById("search-form") as HTMLFormElement;
//   const searchInput = document.getElementById(
//     "open-search"
//   ) as HTMLInputElement;

//   if (form && searchInput) {
//     // console.log('search 11');
//     const currentUrl = window.location.href;
//     // console.log('currentUrl', currentUrl);

//     if (currentUrl.includes("/intl/")) {
//       form.action = form.action.replace("/intl/", "/");
//     }

//     form.addEventListener("submit", function (event) {
//       const searchQuery = searchInput.value.trim();

//       if (searchQuery) {
//         // console.log('search 1222');

//         if (form.action.includes("/intl/")) {
//           form.action = form.action.split("/intl/").join("");
//         }
//       }
//     });
//   }
// };

const currencyCountry = useCookie("altcs_detect_country");

onMounted(() => {
  checkPageCart();
  headerMenuLayoutFive();
  headerUserMenuCloseOutside();
  getOSBrowser();
  layout7HoverEffect();
  // updateFormAction();
  console.log("currencyCountry", currencyCountry.value);
  share_key_cookie.value = userStore.user?.wishlist_sharekey || '';
  const currentShareKey = getCookie("share_key_wishlist");
  if (share_key_cookie.value && currentShareKey !== share_key_cookie.value) {
    setCookie('share_key_wishlist', share_key_cookie.value, 1);
  }
  // if (currencyCountry.value !== "MY" && (showPopUp.value === undefined || showPopUp.value !== 'checked')) {
  //   showSeclect.value = true;
  // }
  watch(
    () => router.currentRoute.value.name,
    () => {
      checkPageCart();
    }
  );
});
</script>
